import { useNavigate } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import type { SearchRow } from '@/api/search';

export interface ResultRowProps {
  row: SearchRow;
  showCustomer: boolean;
}

export function ResultRow({ row, showCustomer }: ResultRowProps) {
  const navigate = useNavigate();
  return (
    <button
      type="button"
      onClick={() => navigate(row.url)}
      className="group flex w-full items-center justify-between gap-3 rounded px-3 py-2 text-left text-sm hover:bg-slate-50"
    >
      <div className="min-w-0 flex-1">
        <div className="flex items-baseline gap-2">
          <span className="truncate font-medium text-slate-800 group-hover:text-blue-700">{row.name}</span>
          <span className="shrink-0 font-mono text-[10px] text-slate-400">{row.ref_label}</span>
        </div>
        {row.snippet && (
          <div className="truncate text-xs text-slate-500">{row.snippet}</div>
        )}
      </div>
      {showCustomer && row.customer_name && (
        <span className="shrink-0 rounded-full bg-slate-100 px-2 py-0.5 text-[10px] font-medium text-slate-600">
          {row.customer_name}
        </span>
      )}
      <ChevronRight className="h-3.5 w-3.5 shrink-0 text-slate-300 group-hover:text-blue-500" />
    </button>
  );
}
